gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

document.addEventListener('load', init());

jQuery('.slider-wrapper').on('init', function(event, slick){
  ScrollTrigger.refresh();
});

function init(){
  initBlogSharePin() // with Pin
  initFadeIn()
  // initValues()

}

function initBlogSharePin() {
  if (document.querySelector('article .post-social-wrapper')) {
    ScrollTrigger.matchMedia({

      "(min-width: 421px)": function() {

        ScrollTrigger.create({
          trigger: 'article .post-social-wrapper',
          start: 'top 180px',
          endTrigger: '.inner-article',
          end: 'bottom 350px',
          pin: true,
          // markers: true,
        })
      }
    });
  }
}

function initFadeIn() {

  const elements = document.querySelectorAll('.fade-in');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            yPercent: 5,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

// TODO FIX BUG WHERE VALUES DONT UPDATE ON RESIZE
function initValues() {
  if (document.querySelector('section.featured-facilities')) {
    ScrollTrigger.matchMedia({

      "(min-width: 421px)": function() {
        const elements = document.querySelectorAll('section.featured-facilities .content');
        // console.log(elements)
        console.log('initValues called')

        if (elements) {
          elements.forEach((el, index) => {
              var offset = el.querySelector('.desc').offsetHeight
              console.log(`offset ${index}`, el.offsetWidth)
              gsap.set(el, {
                  bottom: -offset,
              })
          })
        }

      }
    });
  }
}
